<template>
<div class="background-01">
  <v-layout row wrap>
     <v-flex xs12 sm10>
      <ui-title-red textTitle="Decisiones"></ui-title-red>
    </v-flex>
    <v-flex xs12 sm2 hidden-xs-only>
      <image-app :imaSize="200" imaSrc="design/banco1-1-3-2" imaAlt=""></image-app>
    </v-flex>
    <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Decisiones'" videoEmbed="ADMINISTRACIONDINERO8Decisiones (ant39).mp4"></ui-simple-lsc>
      </v-flex>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm5 class="animated fadeInUp" text-xs-center>
        <image-app :imaSize="233" imaSrc="contenido/diapositiva_10" imaAlt="Mujer sonriendo recostada en el cuadro de texto"></image-app>
      </v-flex>
      <v-flex xs12 sm5 class="aligner animated fadeInRight dura_1">
        <p class="adorn-bottom">Es mucho más fácil tomar las decisiones cuando sabemos para dónde vamos, cuando tenemos claras nuestras <strong>metas</strong>.
        <br><br>Cada <strong>decisión</strong> que tomamos trae consigo una <strong>consecuencia</strong>, por eso <strong>es necesario tomar decisiones efectivas</strong>, es decir,
          que apunten a lo que queremos lograr, optimizando los recursos y siendo congruentes con nuestros objetivos.
          <audio-player ref="audioPlayer" :audios="[
            'Administracion2.mp3'
            ]"></audio-player>
        </p>
      </v-flex>
    </v-layout>
  </v-layout>
</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
    setTimeout(()=>{this.$refs.audioPlayer.playAudio(0)},1000);    
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-09.vue?65df0b5c